import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMemberAuth } from '../../hooks/useMemberAuth';
import { uploadMemberPhoto } from '../../services/member-auth.service';
import PhotoUpload from '../../components/forms/PhotoUpload';
import Button from '../../components/common/Button';
import { Camera, AlertCircle } from 'lucide-react';

/**
 * Tela de bloqueio: o associado só acessa a área do associado
 * após enviar sua foto de cadastro.
 */
const MemberCompletePhoto = () => {
  const navigate = useNavigate();
  const { updateMember } = useMemberAuth();
  const [photoFile, setPhotoFile] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');

    if (!photoFile) {
      setError('A foto é obrigatória.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await uploadMemberPhoto(photoFile);
      updateMember(response.member);
      navigate('/associado/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Erro ao enviar foto.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm border-2 border-brand-beige p-8 space-y-6">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-brand-gold/20 rounded-full flex items-center justify-center">
            <Camera className="h-6 w-6 text-brand-brown" />
          </div>
          <h1 className="mt-4 text-xl font-display font-bold text-brand-brown">
            Complete seu cadastro
          </h1>
          <p className="mt-1 text-sm text-gray-600">
            Para acessar o portal, é necessário enviar uma foto para o seu cadastro.
          </p>
        </div>

        {error && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-start">
            <AlertCircle className="h-5 w-5 text-red-600 mr-2 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-red-700">{error}</p>
          </div>
        )}

        <PhotoUpload value={photoFile} onChange={setPhotoFile} />

        <Button type="button" variant="primary" loading={isLoading} onClick={handleSubmit}>
          Enviar foto e continuar
        </Button>
      </div>
    </div>
  );
};

export default MemberCompletePhoto;
